class CartRecommendations extends HTMLElement {

	constructor(){
		super();
		this.generateRecommendations();
	}

	generateRecommendations(){
		const cartItems = document.getElementById('AjaxCartForm').querySelectorAll('[data-js-cart-item]');
		if ( cartItems.length > 0 ) {
			fetch(`${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${cartItems[0].dataset.productId}&limit=${this.dataset.limit}`)
				.then(response => response.text())
				.then(text => {
					const parsed = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-js-cart-recommendations-performed]');
          if ( parsed && parsed.querySelectorAll('[data-js-product-item]').length > 0 ) {
            const temp = document.createElement('div');
            temp.innerHTML = parsed.innerHTML;
            this.replaceChildren(...temp.childNodes);
          }
				})
		}
	}
}
customElements.define('cart-recommendations', CartRecommendations);